module.exports = __webpack_public_path__ + "img/rightBottom2.ade770d.svg";